import { useMemo } from "react";

import { Module } from "src/api/modulesApi";
import { LifecycleState, ModuleKind } from "src/clients/flow-api";
import { readMcpEnabled } from "src/hooks/useIsMcpModuleEnabled";
import { useWorkspaceContext } from "src/router/routerContextHooks";

// A deployed mcp module is not the same as a workspace that serves MCP: `spec`
// is null until the first COMPLETED operation, and module creation seeds
// `mcp_enabled: false`, so the module can exist while `<base_url>/mcp` still
// 404s. Callers that talk to the MCP endpoint need this, not module presence.
export const isMcpModuleServing = (module: Module): boolean =>
  module.kind === ModuleKind.MCP &&
  Boolean(module.spec?.is_active) &&
  (module.spec?.lifecycle_state ?? LifecycleState.ACTIVE) ===
    LifecycleState.ACTIVE &&
  readMcpEnabled(module.spec);

export const useIsMcpServerEnabled = (): { isEnabled: boolean } => {
  const { modules } = useWorkspaceContext();

  const isEnabled = useMemo(
    () => modules?.some(isMcpModuleServing) ?? false,
    [modules],
  );

  return { isEnabled };
};
